import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Row,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Button,
} from "reactstrap";

import Breadcrumbs from "../../../components/common/Breadcrumb";

import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";

import { AxiosError, AxiosResponse } from "axios";
import { ApiCore } from "../../../helpers/api_helper";
import { Endpoints } from "../../../utils/Endpoints";
import { amountToCurrency, formattedDate } from "../../../utils/Helpers";
import { Link, useHistory, useLocation } from "react-router-dom";
import { invoiceEndDate, invoiceStartDate } from "../../../utils/Helpers";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form, Formik } from "formik";
import { XSelect } from "../../../components/common/inputs/XSelect";
import { XSearchableSelect } from "../../../components/common/inputs/XSearchableSelect";
import { XTextBox } from "../../../components/common/inputs/XTextBox";
import { ISelectOption } from "../../../interfaces/inputs/ISelectOption";
import { XDatePickerField } from "../../../components/common/inputs/XDatePickerField";

const RecordFees = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [banks, setBanks] = useState<any>([]);
  const [debitAccounts, setDebitAccounts] = useState<any>([]);
  const [students, setStudents] = useState<any>([]);
  const [accounts, setAccounts] = useState<any>([]);

  const history = useHistory();
  let initialValues: any = {};

  const terms: ISelectOption[] = [
    { value: "I", text: "I" },
    { value: "II", text: "II" },
    { value: "III", text: "III" },
  ];

  const LoadAccounts = (values: any) => {
    toast
      .promise(request
        .get(Endpoints.getSchoolFeesDefaults, {}), {
        pending: "Please wait..",
        success: {
          render({ data }) {
            return "";
          },
        },
        error: {
          render({ data }) {
            return data;
          },
        },
      })
      .then((response: AxiosResponse) => {
        const { accounts } = response.data;
        setAccounts(accounts);
        setLoading(false);
      })
      .catch(error => {
        console.error(error);
      });
  };


  const request = new ApiCore();

  const recordFees = (values: any) => {
    toast
      .promise(request
        .create(Endpoints.recordFees, values), {
        pending: "Please wait..",
        success: {
          render({ data }) {
            return "";
          },
        },
        error: {
          render({ data }) {
            return data;
          },
        },
      })
      .then((response: AxiosResponse) => {
        console.log(response)
      })
      .catch(error => {
        console.error(error);
      });
  };

  const handleSubmit = (values: any) => {
    console.log(values);
    recordFees(values);
  };

  useEffect(() => {
    LoadAccounts({});
  }, []);

  useEffect(() => {
    request
      .get(Endpoints.getSchoolFeesDefaults, {})
      .then((response: AxiosResponse) => {
        const { banks } = response.data;
        let options: any = [];
        options = banks.map((data: any) => ({
          value: data.id,
          label: data.name + " - " + data.account,
          data: JSON.stringify(data),
        }));
        setBanks(options);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);


  useEffect(() => {
    request
      .get(Endpoints.accounts + "?term=", {})
      .then((response: AxiosResponse) => {
        const { accounts } = response.data;
        let options: any = [];
        options = accounts.map((data: any) => ({
          value: data.id,
          label: data.name,
          data: JSON.stringify(data),
        }));
        setDebitAccounts(options);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);


  useEffect(() => {
    request
      .get(Endpoints.getStudentsList, {})
      .then((response: AxiosResponse) => {
        const { students } = response.data;
        let options: any = [];
        options = students.map((data: any) => ({
          value: data.id,
          label: data.lastname + " " + data.firstname + " - " + data.studentid + " - " + data.form + " " + data.stream,
          data: JSON.stringify(data),
        }));
        setStudents(options);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="page-content">
        <MetaTags>
          <title>Record Fees | Treda - React Admin & Dashboard Template</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="School" breadcrumbItem="Record" />
          <Row>
            <Col lg="12">
              <Card>
                <CardHeader className="justify-content-between d-flex align-items-center">
                  <CardTitle className="h4">Record Fees</CardTitle>

                  <UncontrolledDropdown className="mt-4 mt-sm-0">
                    <DropdownToggle tag="a" className="btn btn-light">
                      <i className="fa fa-ellipsis-v"></i>
                    </DropdownToggle>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  {!loading && (
                    <>
                      <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        validateOnBlur
                        onSubmit={(values: any) => handleSubmit(values)}
                      >
                        {({ isSubmitting, setFieldValue, values, errors, touched }) => (
                          <>
                            <Form>
                              <Row>
                                <Col lg={2}>
                                  <XSearchableSelect
                                    key="bank_id"
                                    id="bank_id"
                                    name={"bank_id"}
                                    options={banks}
                                    label={"Bank"}
                                    onChange={(value: any) => {
                                      setFieldValue("bank_id", value.value);
                                    }}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={3}>
                                  <XSearchableSelect
                                    key="student_id"
                                    id="student_id"
                                    name={"student_id"}
                                    options={students}
                                    label={"Student"}
                                    onChange={(value: any) => {
                                      setFieldValue("student_id", value.value);
                                    }}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XSelect
                                    key="term"
                                    id="term"
                                    name={"term"}
                                    options={terms}
                                    label={"Term"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={1}>
                                  <XTextBox
                                    id="year"
                                    type={"text"}
                                    name={"year"}
                                    label={"Year"}
                                    placeholder="2014"
                                    onChange={(value: any) => {
                                      setFieldValue("year", value.value);
                                    }}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XDatePickerField
                                    key="date"
                                    id="date"
                                    name={"date"}
                                    label={"Date"}
                                    touched={touched}
                                    onChange={setFieldValue}
                                    value={values.date}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XTextBox
                                    id="referenceno"
                                    type={"text"}
                                    name={"referenceno"}
                                    label={"Ref #"}
                                    onChange={(value: any) => {
                                      setFieldValue("referenceno", value.value);
                                    }}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={3}>
                                  <XSearchableSelect
                                    key="draccountid"
                                    id="draccountid"
                                    name={"draccountid"}
                                    options={debitAccounts}
                                    label={"Debit Account"}
                                    onChange={(value: any) => {
                                      setFieldValue("draccountid", value.value);
                                    }}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                              </Row>
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th><b>Account Name</b></th>
                                    <th className="text-center"><b>Amount</b></th>
                                    <th className="text-center"><b>Particulars</b></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {accounts && accounts.map((item: any) => {
                                    return (<><tr key={item.id}>
                                      <td>{item.name}</td>
                                      <td className="text-center">
                                        <XTextBox
                                          id={`account_${item.id}`}
                                          type={"text"}
                                          name={`account[account_${item.id}]`}
                                          touched={touched}
                                          errors={errors}
                                        />
                                      </td>
                                      <td className="text-center">
                                        <XTextBox
                                          id={`account_${item.id}`}
                                          type={"text"}
                                          name={`particulars[account_${item.id}]`}
                                          touched={touched}
                                          errors={errors}
                                        />
                                      </td>
                                    </tr>
                                    </>)
                                  })}
                                </tbody>
                              </table>
                              <Row>
                                <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                  <Button
                                    disabled={isSubmitting}
                                    type="submit"
                                    className="btn btn-primary"
                                  >
                                    Save
                                  </Button>
                                </div>
                              </Row>
                            </Form>
                            <hr />
                          </>
                        )}
                      </Formik>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default RecordFees;
